import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 shadow-sm backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">哔咔漫画</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#sound"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-volume-up-line"></i>
            试听翻页音效
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur-md md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#sound"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-volume-up-line"></i>
            试听翻页音效
          </a>
        </div>
      )}
    </header>
  );
}

export default Navbar;